import { ciHttpRequest } from '@/utils/CiHttpRequest';
import {
	IMaintenanceDetail,
} from './vrmBillMaintenanceRoType';

class MaintenanceRoService {
	async one(id: string) {
		const apiUrl = `/ci/order/return/oneCode/${id}`;
		return await ciHttpRequest.get<IMaintenanceDetail>(apiUrl);
	}
}
export const maintenanceRoService = new MaintenanceRoService();